import React, { useEffect } from 'react';

const RouterSafeErrorPage = ({ error, resetError }) => {
  useEffect(() => {
    if (!document.getElementById('hp2-font-rsep')) {
      const link = document.createElement('link');
      link.id = 'hp2-font-rsep';
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;1,300;1,400&family=Inter:wght@300;400;500&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  const handleGoHome = () => { window.location.href = '/'; };
  const handleRefresh = () => { window.location.reload(); };
  const handleResetError = () => {
    if (resetError) resetError();
    else handleRefresh();
  };

  return (
    <>
      <style>{`
        .rsep2 {
          --rsep-black: #0D0D0D;
          --rsep-cream: #E2D0B0;
          --rsep-cream-mid: #C8B48E;
          --rsep-gold: #C4A25A;
          --rsep-gold-l: #D4B870;
          --rsep-muted: #6B6B6B;
          --rsep-border: rgba(196,162,90,0.22);
          font-family: 'Inter', system-ui, sans-serif;
          min-height: 100vh;
          background: var(--rsep-black);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem 1.5rem;
          position: relative;
          overflow: hidden;
        }
        .rsep2::before {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse 60% 50% at 50% 0%, rgba(196,162,90,0.07) 0%, transparent 70%);
          pointer-events: none;
        }
        .rsep2-card {
          position: relative;
          z-index: 1;
          max-width: 580px;
          width: 100%;
          text-align: center;
        }
        .rsep2-tag {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          color: var(--rsep-gold);
          font-size: 0.68rem;
          font-weight: 500;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          margin-bottom: 2rem;
        }
        .rsep2-tag::before {
          content: '';
          display: block;
          width: 28px;
          height: 1px;
          background: var(--rsep-gold);
        }
        .rsep2-icon {
          width: 88px;
          height: 88px;
          margin: 0 auto 2rem;
          border: 1px solid var(--rsep-border);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(196,162,90,0.05);
        }
        .rsep2-icon svg {
          width: 36px;
          height: 36px;
          stroke: var(--rsep-gold);
          fill: none;
        }
        .rsep2-num {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: 7rem;
          font-weight: 300;
          color: rgba(196,162,90,0.08);
          line-height: 1;
          margin-bottom: -1rem;
          letter-spacing: -0.02em;
          position: relative;
          z-index: 0;
          pointer-events: none;
        }
        .rsep2-heading {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: clamp(2.2rem, 5vw, 3rem);
          font-weight: 300;
          color: var(--rsep-cream);
          line-height: 1.15;
          margin: 0 0 1rem;
          position: relative;
          z-index: 1;
        }
        .rsep2-heading em { font-style: italic; color: var(--rsep-gold); }
        .rsep2-divider {
          width: 44px;
          height: 1px;
          background: var(--rsep-gold);
          opacity: 0.4;
          margin: 0 auto 1.5rem;
        }
        .rsep2-body {
          font-size: 0.9rem;
          color: var(--rsep-muted);
          font-weight: 300;
          line-height: 1.7;
          margin: 0 0 0.5rem;
        }
        .rsep2-resort {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: 0.95rem;
          color: var(--rsep-cream-mid);
          font-style: italic;
          letter-spacing: 0.05em;
        }
        .rsep2-dev {
          margin: 1.5rem auto 0;
          padding: 1.25rem 1.5rem;
          background: rgba(196,162,90,0.04);
          border: 1px solid var(--rsep-border);
          text-align: left;
          max-width: 480px;
        }
        .rsep2-dev h3 {
          font-size: 0.65rem;
          font-weight: 500;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--rsep-gold);
          margin: 0 0 0.625rem;
          font-family: 'Inter', sans-serif;
        }
        .rsep2-dev pre {
          font-size: 0.76rem;
          color: var(--rsep-muted);
          overflow-x: auto;
          max-height: 100px;
          margin: 0;
          font-family: 'Courier New', monospace;
          white-space: pre-wrap;
          word-break: break-word;
        }
        .rsep2-actions {
          display: flex;
          flex-direction: column;
          gap: 0.875rem;
          margin: 2.5rem 0;
          align-items: center;
        }
        @media (min-width: 480px) {
          .rsep2-actions { flex-direction: row; justify-content: center; }
        }
        .rsep2-btn-gold {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 0.875rem 2.25rem;
          background: var(--rsep-gold);
          color: var(--rsep-black);
          font-family: 'Inter', sans-serif;
          font-size: 0.72rem;
          font-weight: 500;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          border: none;
          cursor: pointer;
          transition: background 0.2s;
          text-decoration: none;
          min-width: 160px;
        }
        .rsep2-btn-gold:hover { background: var(--rsep-gold-l); }
        .rsep2-btn-ghost {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 0.875rem 2.25rem;
          background: transparent;
          color: var(--rsep-cream);
          font-family: 'Inter', sans-serif;
          font-size: 0.72rem;
          font-weight: 500;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          border: 1px solid rgba(226,208,176,0.25);
          cursor: pointer;
          transition: border-color 0.2s, color 0.2s;
          text-decoration: none;
          min-width: 160px;
        }
        .rsep2-btn-ghost:hover { border-color: var(--rsep-gold); color: var(--rsep-gold); }
        .rsep2-contact {
          border: 1px solid var(--rsep-border);
          background: rgba(255,255,255,0.01);
          padding: 2rem 2.5rem;
          max-width: 420px;
          margin: 0 auto;
        }
        .rsep2-contact-title {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: 1.2rem;
          font-weight: 300;
          color: var(--rsep-cream);
          margin: 0 0 0.5rem;
        }
        .rsep2-contact-sub {
          font-size: 0.8rem;
          color: var(--rsep-muted);
          font-weight: 300;
          margin: 0 0 1.25rem;
          line-height: 1.6;
        }
        .rsep2-contact-links {
          display: flex;
          flex-direction: column;
          gap: 0.625rem;
          align-items: center;
        }
        @media (min-width: 420px) {
          .rsep2-contact-links { flex-direction: row; justify-content: center; }
        }
        .rsep2-contact-links a {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          color: var(--rsep-gold);
          font-size: 0.8rem;
          font-weight: 300;
          text-decoration: none;
          transition: color 0.2s;
        }
        .rsep2-contact-links a:hover { color: var(--rsep-gold-l); }
        .rsep2-contact-links svg { width: 14px; height: 14px; stroke: currentColor; fill: none; }
        .rsep2-footer {
          margin-top: 2.5rem;
          font-size: 0.68rem;
          color: rgba(107,107,107,0.5);
          letter-spacing: 0.06em;
        }
      `}</style>

      <div className="rsep2">
        <div className="rsep2-card">
          <div className="rsep2-tag">System Error</div>

          <div className="rsep2-icon">
            <svg viewBox="0 0 24 24" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
            </svg>
          </div>

          <h1 className="rsep2-heading">
            Something went <em>wrong</em>
          </h1>
          <div className="rsep2-divider" />
          <p className="rsep2-body">
            We encountered an unexpected error at{' '}
            <span className="rsep2-resort">Swat Capital Resort</span>
          </p>
          <p className="rsep2-body" style={{ marginTop: '0.5rem' }}>
            Our team has been notified and is working to resolve this promptly.
          </p>

          {process.env.NODE_ENV === 'development' && error && (
            <div className="rsep2-dev">
              <h3>Error Details — Dev Mode</h3>
              <pre>{error.toString()}</pre>
            </div>
          )}

          <div className="rsep2-actions">
            <button onClick={handleResetError} className="rsep2-btn-gold">
              <svg viewBox="0 0 24 24" strokeWidth={2} fill="none" style={{ width: 14, height: 14 }}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
              </svg>
              Try Again
            </button>
            <button onClick={handleGoHome} className="rsep2-btn-ghost">
              <svg viewBox="0 0 24 24" strokeWidth={1.5} fill="none" style={{ width: 14, height: 14 }}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
              </svg>
              Go to Homepage
            </button>
          </div>

          <div className="rsep2-contact">
            <h3 className="rsep2-contact-title">Need assistance?</h3>
            <p className="rsep2-contact-sub">Our support team is available 24 / 7.</p>
            <div className="rsep2-contact-links">
              <a href="tel:+923329622132">
                <svg viewBox="0 0 24 24" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                </svg>
                +92 332 9622132
              </a>
              <a href="mailto:support@swatcapitalresort.com">
                <svg viewBox="0 0 24 24" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
                support@swatcapitalresort.com
              </a>
            </div>
          </div>

          <div className="rsep2-footer">
            Error ID: {Date.now().toString(36).toUpperCase()} &nbsp;·&nbsp; {new Date().toLocaleString()}
          </div>
        </div>
      </div>
    </>
  );
};

export default RouterSafeErrorPage;
